export const useDemoProfile = (): string | null => {
	const params = new URLSearchParams(window.location.search)
	const demoProfile = params.get('demoProfile')

	return demoProfile
}
